import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

interface AddProductType {
  product: any;
  setProduct: (value: any) => void;
  category: any;
  setCategory: (value: any) => void;
  showAddProduct: boolean;
  setShowAddProduct: (value: boolean) => void;
  redirectToProductSlug: any;
  setRedirectToProductSlug: (value: string) => void;
}

const AddProductContext = createContext<AddProductType | undefined>(undefined);

export const AddProductProvider = ({ children }: { children: ReactNode }) => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [product, setProduct] = useState(null);
  const [category, setCategory] = useState(null);
  const [redirectToProductSlug, setRedirectToProductSlug] = useState(() => localStorage.getItem('redirect_product_slug') || null);

  useEffect(() => {
    if (redirectToProductSlug) {
      localStorage.setItem('redirect_product_slug', redirectToProductSlug)
    } else {
      localStorage.removeItem('redirect_product_slug')
    }
  }, [redirectToProductSlug]);


  return (
    <AddProductContext.Provider value={{
        showAddProduct, setShowAddProduct,
        product, setProduct,
        category, setCategory,
        redirectToProductSlug, setRedirectToProductSlug,
      }}>
      {children}
    </AddProductContext.Provider>
  );
};

export const useAddProductContext = () => {
  const context = useContext(AddProductContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
